<template>
  <div class="formGroup" :data-layout="layout">
    <input type="hidden" :name="name" :value="rawValue" v-validate:rawValue="validation">
    <div class="formGroup__body" :class="{disabled: isDisabled}">
      <formLabel :label="label"></formLabel>
      <div class="timeInput">
        <input
          class="formControl timehoge"
          data-size="small"
          :placeholder="placeholder"
          type="tel"
          :data-error="errors.has(name)"
          ref="input"
          @input="changeNext"
          @click="selectAll($event.target)"
        >
      </div>
    </div>
    <div class="formGroup__footer">
      <p class="formGroup__errorMessage">{{ errors.first(name) }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-birthtime',
  mixins: [mixin],
  data(){
    return {
      $input: null,
      rawValue: ''
    }
  },
  props: {
    name: { type: String, required: true },
    value: [Object, String],
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    value(){
      this.$input.value = this.value.replace(':', ' : ')
      this.changeNext()
    }
  },

  mounted() {
    this.onMounted()
  },

  methods: {
    onMounted() {
      this.$input = this.$refs.input
      this.$input.value = ':'
    },
    selectAll(target) {
      target.setSelectionRange(0, 7)
    },
    changeNext() {
      let rtn = ''
      if(/^[^\d]/.test(this.$input.value)) this.$input.value = this.$input.value.substring(1)
      else if(/^\d\d :$/.test(this.$input.value)) this.$input.value = this.$input.value.substring(0, 1)
      const v = this.$input.value.replace(' : ', '').split('')
      // console.log('input[%O] v[%O]', this.$input.value , v)
      switch (v.length){
        case 0:
          rtn = ':'
          break
        case 1:
          if(+v[0] > 2){
            rtn = `0${v[0]} : `
          } else {
            rtn = v[0]
          }
          break
        case 2:
          rtn = `${v.join('')} : `
          break
        case 3:
          if(+v[2] > 5){
            rtn = `${[v[0],v[1]].join('')} : 0${v[2]}`
          }else {
            rtn = `${[v[0],v[1]].join('')} : ${v[2]}`
          }
          break
        default:
          rtn = `${[v[0],v[1]].join('')} : ${[v[2],v[3]].join('')}`
      }
      this.rawValue = /^[0-2]\d : [0-5]\d/.test(rtn) ? `${[v[0],v[1]].join('')}:${[v[2],v[3]].join('')}` : ''
      this.$input.value = rtn
      this.update()
    },
    update() {
      this.$emit('input', this.rawValue)
    },
  }
}</script>

<style lang="scss" scoped>
.buttonGroup {
  display: flex;
  height: 36px;
  &__item {
    min-width: 72px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #000000;
    background: rgba(248, 248, 248, 0.9);
    cursor: pointer;
    color: #000000;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-radius: 0 4px 4px 0;
    }
    &[data-active='true'] {
      background: #000000;
      border-color: #000000;
      color: #fff;
      font-weight: bold;
    }
  }
}
.timeInput {
  display: inline-flex;
  align-items: center;
  color: #fff;
  .formControl {
    width: 80px;
    background: #fff;
    text-align: center;
    &:focus {
      border-color: rgba(0, 0, 0, 0.15);
    }
  }
  > span {
    margin: 0 0.5em;
  }
}
.formGroup__body {
  &.disabled {
    .timeInput {
      .formControl {
        color: #ccc;
        pointer-events: none;
        user-select: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormBirthtimeSimple.vue